export const GET_USER = 'GET_USER';
export const SET_USER_INFO = 'SET_USER_INFO';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_LOADING = 'SET_LOADING';
export const GET_CUST_ID = 'GET_CUST_ID';
export const SET_OTP_SUCCESS = 'SET_OTP_SUCCESS';
export const GET_REF_BDAY = 'GET_REF_BDAY';
export const POST_OTP_REQUEST = 'POST_OTP_REQUEST';
export const POST_OTP_VALIDATE = 'POST_OTP_VALIDATE';
export const POST_STATUS_UPDATE = 'POST_STATUS_UPDATE';
export const GET_COMPLIANCE_DOC = 'GET_COMPLIANCE_DOC';
export const POST_UPLOAD_DOCU = 'POST_UPLOAD_DOCU';
export const POST_SAVE_DOC = 'POST_SAVE_DOC';
export const NEXT_STEP = 'NEXT_STEP';
export const ADD_DOC = 'ADD_DOC';
export const UPLOAD_FILES = 'UPLOAD_FILES';
export const UPLOAD_DOCUMENTS = 'UPLOAD_DOCUMENTS';
export const GET_UPLOADED_DOCUMENT = 'GET_UPLOADED_DOCUMENT';
export const GET_DOCUMENT_ITEM = 'GET_DOCUMENT_ITEM';
export const DELETE_DOCUMENT_ITEM = 'DELETE_DOCUMENT_ITEM';

export const GET_COMPLIANCE_DOCUMENTS = 'GET_COMPLIANCE_DOCUMENTS';
export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
export const REMOVE_DOCUMENT = 'REMOVE_DOCUMENT';
export const ADD_NO_SUBMITTED_DOCUMENTS = 'ADD_NO_SUBMITTED_DOCUMENTS';
export const DONE_PROCESS = 'DONE_PROCESS';
export const ADD_NO_DELETED_DOCUMENTS = 'ADD_NO_DELETED_DOCUMENTS';
export const SET_TOKEN = 'SET_TOKEN';
export const GET_TOKEN = 'GET_TOKEN';

export const GET_APPLICATION_DETAILS = 'GET_APPLICATION_DETAILS';
export const GET_VIDEO_CALL_SCHEDULE = 'GET_VIDEO_CALL_SCHEDULE';
export const SET_VIDEO_CALL_SCHEDULE = 'SET_VIDEO_CALL_SCHEDULE';
export const SET_DISPLAY_VIDEO_CALL_SCHEDULE = 'SET_DISPLAY_VIDEO_CALL_SCHEDULE';

export const SET_ATM_CARD_NUMBER = 'SET_ATM_CARD_NUMBER';
export const SET_ATM_CARD_BIRTHDAY = 'SET_ATM_CARD_BIRTHDAY';
export const NOMINATE_PIN = 'NOMINATE_PIN';
export const SUBMIT_NOMINATED_PIN = 'SUBMIT_NOMINATED_PIN';
export const ATM_CARD_VALIDATION = 'ATM_CARD_VALIDATION';
export const ATM_CARD_ACTIVATION_SUBMIT = 'ATM_CARD_ACTIVATION_SUBMIT';
export const SET_NOMINATED_PIN = 'SET_NOMINATED_PIN';
export const CARD_SESSION_VALIDATION = 'CARD_SESSION_VALIDATION';
export const CHANGE_ATM_PIN = 'CHANGE_ATM_PIN';
export const SET_OLD_PIN = 'SET_OLD_PIN';
export const SET_LOCAL_IP = 'SET_LOCAL_IP';
export const SET_REF_CODE = 'SET_REF_CODE';
export const OLD_PIN_VALIDATION = 'OLD_PIN_VALIDATION';
export const ACTIVATION_CODE_VALIDATION = 'ACTIVATION_CODE_VALIDATION';
